import React, { Component } from 'react';
import { map, isEmpty, flatMap } from 'lodash';
import moment from 'moment-timezone';
// import Script from 'react-load-script';
import DataTable from '../DataTable';
import PaymentHistory from './PaymentHistory';
import ViewEditInvoice from "./ViewEditInvoice";
import LogPayment from "../../Common/LogPayment";
import PrePayment from "../../Common/PrePayment";
import AddNewInvoiceNew from "./AddNewInvoiceNew";
import RefundPayment from "../../Common/RefundPayment";
import Loader from "../../../../../Common/Component/Loader";
import TypeOutsideAlerter from '../../../../../Common/typeOutsideAlerter';
import { formatToCurrency } from "../../../../../../Tools/formatToCurrency";
import { injectInvoicesStore } from '../../../../../../Stores/InvoicesStore';
import '../../../../../ResidentialManagement/CustomerDetail/Component/Service/Invoices/css/invoice.css';
import AddCreditMemo from '../../../../../ResidentialManagement/CustomerDetail/Component/Service/Invoices/AddCreditMemo';

import { DownOutlined } from '@ant-design/icons';
import { Table, Dropdown, Menu,Select, message, Modal, DatePicker } from 'antd';
// mapping status
const status = [
  { key: 'All', value: 'all' },
  { key: 'Open', value: 'open, open-emailed, open-printed' },
  { key: 'Overdue', value: 'overdue' },
  { key: 'Paid', value: 'paid' },
  { key: 'Draft', value: 'draft' }
]
const row_action = {
  none: '',
  print: 'Print',
  view: 'View/Edit',
  resend: 'Resend',
  log: 'Log Payment',
  refund: 'Refund Payment',
  delete: 'Delete',
  void: 'Void',
  payment_history: 'Payment History',
  actionIssueRefund:false,
}

const row_action_credit_memo = {
  'view-credit-memo' : 'View/Edit'
}
const { Option } = Select;
class Invoices extends Component {
  state = {
    loader: false,
    invoiceList: {},
    invoicePagination: { showSizeChanger: false, pageSize: 10, ordering: "", current: 1 },
    statusFilter: 'all',
    action: '',
    showLogPayment: false,
    showManualLogPayment: false,
    showRefundPayment: false,
    showCreatePrePay: false,
    invoice_uuid: '',
    creditMemo_uuid:'',
    addLog: {},
    currentTab: 0,
    showDelete: false,
    deleteInvoice: {},
    editInvoice: {},
    voidInvoice:{},
    invoiceSummary: {},
    active_action_uuid: '',
    is_export_popup: false,
    export_statement_data: { invoice_date__gte: moment(), invoice_date__lte: moment(), format: 'pdf' },
    service_order_uuid: '',
    logged_in_user_role: [],
    actionValue: null,
    refundTypeValue: null,
    creditMemoDetail:{},
    type: null,
    toggleTypeFilter: false,
  }

  componentDidMount() {
    const {fromOverview, invoice_id, service_order_uuid} = this.props;
    this.getInvoiceList();
    this.getInvoiceSummary();

    if (fromOverview.is)
    {
      if (fromOverview.to === "view") {
        this.onActionChange('view', invoice_id, service_order_uuid)
      }
      if (fromOverview.to === "payment_history") {
        this.onActionChange('payment_history', invoice_id)
      }
      if (fromOverview.to === "credit_memo") {
        this.onActionChange('view-credit-memo', invoice_id)
      }
    }

    // get logged in user roles
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
    this.setState({logged_in_user_role})
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setState({ loader: false })
    const { list, addLog, editInvoice, deleteInvoice, invoiceSummary, voidInvoice, invoicePagination } = this.state;

    //Get invoice Credit Memo list
    if (Object.keys(nextProps?.Invoice?.InvoiceCreditMemoList).length > 0
      && JSON.stringify(nextProps?.Invoice?.InvoiceCreditMemoList) !== JSON.stringify(list)) {
      this.setState({ 
        list: nextProps?.Invoice?.InvoiceCreditMemoList,
        invoicePagination: {...invoicePagination, total: nextProps?.Invoice?.InvoiceCreditMemoList.count }, 
        loader: false 
      }, () => this.getInvoiceSummary())
    }

    // get invoice list
    if (Object.keys(nextProps?.Invoice?.list).length > 0
      && JSON.stringify(nextProps?.Invoice?.list) !== JSON.stringify(list)) {
      this.setState({ list: nextProps?.Invoice?.list }, () => this.getInvoiceSummary())
    }

    // add log payment
    if (Object.keys(nextProps?.Invoice?.add).length > 0
      && JSON.stringify(nextProps?.Invoice?.add) !== JSON.stringify(addLog)) {
      this.setState({ addLog: nextProps?.Invoice?.add })
      this.getInvoiceList();
      this.getInvoiceSummary();
      // this.toggleLog(false)
    }

    // edit invoice
    if (Object.keys(nextProps?.Invoice?.editInvoice).length > 0
      && JSON.stringify(nextProps?.Invoice?.editInvoice) !== JSON.stringify(editInvoice)) {
      this.setState({ editInvoice: nextProps?.Invoice?.editInvoice }, () => this.getInvoiceList())
    }

    //delete record
    if (Object.keys(nextProps.DeleteInvoice.data).length > 0 && nextProps.DeleteInvoice.data !== this.props.DeleteInvoice.data) {
      message.success(nextProps.DeleteInvoice.data?.message, 10);
      this.setState({
        loader: false,
        invoice_uuid:''
      });
      // let data = {
      //   offset: (account_list_pagination.current * 15) - 15,
      //   limit: active_pagination,
      //   ...account_list_filter,
      //   search: search_value,
      // }
      // Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
      this.getInvoiceList()
    }

    // delete invoice
    if (Object.keys(nextProps?.Invoice?.deleteInvoice).length > 0
      && JSON.stringify(nextProps?.Invoice?.deleteInvoice) !== JSON.stringify(deleteInvoice)) {
      this.setState({ deleteInvoice: nextProps?.Invoice?.deleteInvoice,invoice_uuid:'',loader:false }, () => this.getInvoiceList())
    }

    // Invoice summary
    if (Object.keys(nextProps?.Invoice?.invoiceSummary).length > 0
      && JSON.stringify(nextProps?.Invoice?.invoiceSummary) !== JSON.stringify(invoiceSummary)) {
      this.setState({ invoiceSummary: nextProps?.Invoice?.invoiceSummary })
    }

    // Void invoice
    if (Object.keys(nextProps?.VoidInvoice?.data).length > 0 && JSON.stringify(nextProps?.VoidInvoice?.data) !== JSON.stringify(voidInvoice)) {
      this.setState({ voidInvoice: nextProps?.VoidInvoice?.data, loader: false })
      this.getInvoiceList();
    }

    //Export PDF Invoice
    if (Object.keys(nextProps.PDFExportStatement.data).length > 0 && nextProps.PDFExportStatement.data !== this.props.PDFExportStatement.data) {


      var byteCharacters = atob(nextProps?.PDFExportStatement?.data?.data);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], { type: 'application/pdf;base64' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);

      this.setState({loader: false});
    }
    if (Object.keys(nextProps.PDFExportStatement.errors).length > 0 && nextProps.PDFExportStatement.errors !== this.props.PDFExportStatement.errors) {
      // display error messsage
      this.setState({ loader: false });
      message.error('Something went wrong', 10);
    }
    //Export CSV Invoice
    if (Object.keys(nextProps.GetAccountList.data).length > 0 && nextProps.GetAccountList.data !== this.props.GetAccountList.data) {

      let data = nextProps.GetAccountList.data;
      var blob = new Blob([data], { type: 'application/CSV' });

      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'ExportStatement.csv';
      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      this.setState({loader: false});
    }
    if (Object.keys(nextProps.GetAccountList.errors).length > 0 && nextProps.GetAccountList.errors !== this.props.GetAccountList.errors) {
      // display error messsage
      this.setState({ loader: false });
      message.error('Something went wrong', 10);
    }

    this.setState({ loader: false });
  }

  // Get logged in user
  getLoggedInUserRole = () => {
    const {logged_in_user_role} = this.state;
    const authUser = JSON.parse(localStorage.getItem('authUser'));
    const is_call_center = logged_in_user_role?.includes('service_rep')
    const field_office_uuid_list = authUser?.user?.field_offices?.map(x => x.uuid)
    const is_business_dev_franchiese = logged_in_user_role?.includes('business_dev_franchiese')
    return {is_call_center, field_office_uuid_list, is_business_dev_franchiese}
  }

  getInvoiceSummary = () => {
    this.setState({ loader: true })
    this.props.getInvoiceSummary({ user__uuid: this.props.customerId });
  }

  onTypeFilterChange = (e) =>{
    this.setState({ type: e.target.value }, () => this.getInvoiceList(this.state.statusFilter))
    this.setState({toggleTypeFilter: !this.state.toggleTypeFilter})
  }

  // Get invoice list
  getInvoiceList = (status = 'all') => {
    const { customerId, getInvoiceCreditMemoList } = this.props;
    const { invoicePagination,type,statusFilter } = this.state;
    if (customerId) {
      this.setState({ loader: true });
      getInvoiceCreditMemoList && getInvoiceCreditMemoList({
        user__uuid: customerId,
        limit: invoicePagination.pageSize,
        offset: 0,
        status: statusFilter === 'all' ? '' : statusFilter,
        type: type === "null" ? null : type 
      });
    }
  }

  // toggle delete modal
  toggleDeleteModal = () => {
    this.setState((prevState) => ({ showDelete: !prevState.showDelete }))
  }

  // on change View
  onChangeView = (value) => {
    this.setState({ currentTab: value })
    if(value===0){
      this.props.getCustomerDetail(this.props.customerId)
      this.getInvoiceList();
      this.setState({invoice_uuid:'',creditMemo_uuid:''})
    }
  }

  // on filter change
  onFilterChange = (value) => {
    this.setState({ statusFilter: value }, () => this.getInvoiceList(value))
  };

  //Table Order and Pagination
  onInvoiceChange = (pagination) => {
    const { invoicePagination, statusFilter,type } = this.state;
    const { customerId, getInvoiceCreditMemoList } = this.props;
    Object.assign(invoicePagination, { current: pagination.current });

    this.setState({
      invoicePagination,
      loader: true,
    });
    //'9262186d-f2f7-4643-98a7-6680ddd04e11'
    getInvoiceCreditMemoList && getInvoiceCreditMemoList({
      user__uuid: customerId, limit: invoicePagination.pageSize,
      offset: ((pagination.current - 1) * invoicePagination.pageSize),
      status: statusFilter === 'all' ? '' : statusFilter,type:type
    })
  }

  // toggle log payment drawer
  toggleLog = (value) => {
    this.setState({ showLogPayment: value })
  };

  // toggle log payment drawer
  toggleRefund = (value) => {
    this.setState({ showRefundPayment: value })
  };

  // toggle loader
  toggleLoader = (value) => {
    this.setState({ loader: value })
  };

  togglePrePay = (value) => {
    this.setState({ showCreatePrePay: value, actionValue:null});
  };

  // delete invoice
  onDeleteInvoice = () => {
    this.setState({ loader: true })
    this.props.deleteAccountInvoice({multiple_invoices_uuid:this.state.invoice_uuid})
    // this.props.deleteInvoice(this.state.invoice_uuid)
    setTimeout(() => { this.toggleDeleteModal() }, 1000)
  }

  onActionChange = (e, invoice_uuid, service_order_uuid = '') => {
    this.setState({ action: e, active_action_uuid: invoice_uuid }, () => {
      const { action } = this.state;
      switch (action) {
      case 'print':
        this.setState({ loader: true }, () => this.props.printInvoices({ multiple_invoices_uuid: invoice_uuid,user_uuid: this?.props?.customerId }));
        break;
      case 'view':
        this.setState({ invoice_uuid, service_order_uuid }, () => this.onChangeView(1))
        break;
      case 'resend':
        this.setState({ loader: true }, () => this.props.resendInvoice(invoice_uuid))
        setTimeout(() => this.setState({ loader: false }), 1000)
        break;
      case 'log':
        this.setState({ invoice_uuid }, () => this.toggleLog(true))
        break;
      case 'refund':
        this.setState({ invoice_uuid,actionIssueRefund:false }, () => this.toggleRefund(true))
        break;
      case 'delete':
        this.setState({ invoice_uuid }, () => this.toggleDeleteModal())
        break;
      case 'void':
        this.setState({ loader: true }, () => this.props.voidInvoice(invoice_uuid))
        setTimeout(() => this.setState({ loader: false }), 1000)
        break;
      case 'payment_history':
        this.setState({ invoice_uuid }, () => this.onChangeView(3));
        break;
      case 'view-credit-memo':
        this.setState({ creditMemo_uuid:invoice_uuid }, () => this.onChangeView(4));
        break;
      default:
        console.log('no action')
      }
    })
  }

  changeAction = (value) =>{
    switch(value)
    {
    case "refund":
      this.setState({ actionIssueRefund:true,actionValue:value,refundTypeValue:value }, () => this.toggleRefund(true));
      break;
    case "payment":
      this.setState({showManualLogPayment: true, actionValue: value}, () => this.toggleManualLog(true));
      break;
    case "memo":
      this.onChangeView(4);
      break;
    case "pre-payment":
      this.setState({showCreatePrePay: true, actionValue: value}, () => this.togglePrePay(true));
    }
  }

  closeTypeFilter = () => {
    this.setState({ toggleTypeFilter: false })
  }

  // toggle manual log payment drawer
  toggleManualLog = (value) => {
    this.setState({ showManualLogPayment: value, actionValue:null })
  }

  // toggle log payment drawer
  toggleRefund = (value) => {
    this.setState({ showRefundPayment: value,actionValue:null })
  };

  // render table action
  renderAction = (invoice_uuid = '', service_order_uuid = '', status = '', record,creditMemo_id) => {
    const {customer} = this.props;
    const { action, active_action_uuid } = this.state;
    const {is_call_center, field_office_uuid_list, is_business_dev_franchiese} = this.getLoggedInUserRole()
    // check that current logged in user field office uuid and selected customer field office uuid is same or not
    const is_field_office_uuid = field_office_uuid_list?.includes(customer?.field_office_uuid)

    const menu = (
      <Menu>
        <Menu.Item 
          key="0" 
          onClick={() => this.onActionChange('print', invoice_uuid)}
        >
          Print
        </Menu.Item>
        <Menu.Item 
          key="1" 
          onClick={() => this.onActionChange('view', invoice_uuid, service_order_uuid)}
        >
          View/Edit
        </Menu.Item>
        <Menu.Item 
          key="2" 
          disabled={(is_call_center || is_business_dev_franchiese || record?.status === "draft")}
          onClick={() => this.onActionChange('resend', invoice_uuid)}
        >
          Resend
        </Menu.Item>
        <Menu.Item 
          key="3" 
          disabled={(is_business_dev_franchiese || (is_call_center && is_field_office_uuid) || status === 'paid' || record?.status === "draft" || parseFloat(record?.balance_due)<=0)}
          onClick={() => this.onActionChange('log', invoice_uuid)}
        >
          Log Payment
        </Menu.Item>
        <Menu.Item 
          key="4" 
          disabled={(is_business_dev_franchiese || (is_call_center && is_field_office_uuid) || record?.status === "draft")}
          onClick={() => this.onActionChange('refund', record)}
        >
          Refund Payment
        </Menu.Item>
        <Menu.Item 
          key="5" 
          disabled={(is_call_center || is_business_dev_franchiese)} onClick={() => this.onActionChange('delete', invoice_uuid)}
        >
          Delete
        </Menu.Item>
        <Menu.Item 
          key="6" 
          disabled={(is_call_center || is_business_dev_franchiese)}
          onClick={() => this.onActionChange('void', invoice_uuid)}
        >
          Void
        </Menu.Item>
        <Menu.Item 
          key="7" 
          disabled={(is_call_center || is_business_dev_franchiese || record?.status === "draft")}
          onClick={() => this.onActionChange('payment_history', invoice_uuid)}
        >
          Payment History
        </Menu.Item>
      </Menu>
    );

    const cm_menu = (
      <Menu>
        <Menu.Item key="1" onClick={() => this.onActionChange('view-credit-memo',invoice_uuid)}>View/Edit</Menu.Item>
      </Menu>
    ) ;

    return (
      <Dropdown overlay={creditMemo_id?cm_menu:menu} trigger={['click']} className="simple_select">
        <span onClick={e => e.preventDefault()} style={{ width: (active_action_uuid === invoice_uuid) ? "10px" : "" }}>
          {(active_action_uuid === invoice_uuid) ? creditMemo_id?row_action_credit_memo[action]:row_action[action] : 'Select'} <DownOutlined style={{marginLeft: "25px"}}/>
        </span>
      </Dropdown>
    )
  }

  renderList = () => {
    let { invoicePagination, list, statusFilter, invoiceSummary,actionValue,actionIssueRefund,toggleTypeFilter } = this.state;
    const {is_call_center, is_business_dev_franchiese} = this.getLoggedInUserRole()

    return (
      <TypeOutsideAlerter
        closeTypeFilter={this.closeTypeFilter}>  
        <div>
          <div className="flex">
            <div className="inleft flex">
              <div className="tblock">
                <div className="trow">
                  <b>Open Invoice Balance</b>
                  <b className="tcell">${!isEmpty(invoiceSummary?.open_invoices_amount?.total__sum) ? formatToCurrency(invoiceSummary?.open_invoices_amount?.total__sum) : '0.00'}</b>
                </div>
                <div className="trow">
                  <span>Credit Balance</span>
                  <span>${!isEmpty(invoiceSummary?.credit_memo_balance) ? formatToCurrency(invoiceSummary?.credit_memo_balance) : '0.00'}</span>
                </div>
                <div className="trow">
                  <span>Pre-pay Balance</span>
                  <span>${invoiceSummary?.pre_pay_amount ? formatToCurrency(invoiceSummary?.pre_pay_amount) : '0.00'}</span>
                </div>
                <div className="trow">
                  <span>Paid to Date</span>
                  <span>${!isEmpty(invoiceSummary?.paid_to_date) ? formatToCurrency(invoiceSummary?.paid_to_date) : '0.00'}</span>
                </div>
              </div>
              <div className="tblock">
                <b className="mb-10 d-block">{invoiceSummary?.open_invoices_count || 0} Invoices.</b>
                <span className="danger">
                  <u>{invoiceSummary?.overdue_invoices_count || 0} Overdue </u>
                </span>
              </div>
            </div>
            <div className="inright flex flex-end">
              <div className="flex flex-column dropdown-sel">
                <Select
                  placeholder="Action"
                  style={{ width: 160}}
                  onChange={this.changeAction}
                  className="dark-background text-white"
                  dropdownStyle={{color: "white"}}
                  value={actionValue?actionValue:"Action"}
                >
                  <Option value="memo">Create Credit Memo</Option>
                  <Option value="payment">Log Payment</Option>
                  <Option value="refund">Issue Refund</Option>
                  <Option value="pre-payment">Create Pre-pay</Option>
                </Select>
              </div>
              <div className="flex flex-column ml-30">
                <button className={`btn ${(is_call_center) ? 'disabled' : 'btn-brand btn-bdr'} ml-0`} disabled={(is_call_center)} onClick={() => this.setState({ is_export_popup: true })}>Export Statement</button>
              </div>
              <div className="flex flex-column ml-30">
                <button className={`btn ${(is_call_center || is_business_dev_franchiese) ? 'disabled' : 'btn-warning'} mb-10`} disabled={(is_call_center || is_business_dev_franchiese)} onClick={() => this.onChangeView(1)}>Add New Invoice</button>
              </div>
            </div>
          </div>
          <div className="inright flex flex-end ml-10 mb-10">
            <div className="form-group image-input type-border">
              <div className="" onClick={() => { this.setState({toggleTypeFilter: !toggleTypeFilter}) }}>
                <input type="text" id="txtStatus" value={this.state.type==="invoice"?"Invoice":this.state.type==="creditmemo"?"Credit Memo":"All"} placeholder="Type : All" />
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGBAMAAAAI3hL1AAAAAXNSR0IB2cksfwAAABhQTFRFAAAAHR0iHR0gHBwgHBwgHBwiHBwhHB0hNAFBfQAAAAh0Uk5TADSGiIeJiouH2FuSAAAAKElEQVR4nGMQYGBgYGRQBpJGDCwBDKwODAxuDClALks5kMnA4MLAAAAopwKpSq6gTAAAAABJRU5ErkJggg==" alt=""/>
              </div>
              {toggleTypeFilter && <div className="field-dropdown right type-body" style={{minHeight: '125 px !important',}}>
                <div className="field-dropdown-body type-body">
                  <div className="fitem-check">
                    <input id="All" type="checkbox" checked={this.state.type==="null"?true:false} value={"null"}  onChange={this.onTypeFilterChange} className="fitem-ck-input"/>
                    <label htmlFor="All" className="fitem-ck-txt">All</label>
                  </div>
                  <div className="fitem-check">
                    <input id="paused" type="checkbox" checked={this.state.type==="invoice"?true:false} value={"invoice"}  onChange={this.onTypeFilterChange} className="fitem-ck-input"/>
                    <label htmlFor="paused" className="fitem-ck-txt">Invoice</label>
                  </div>
                  <div className="fitem-check">
                    <input id="technician_assigned" checked={this.state.type==="creditmemo"?true:false} value={"creditmemo"} onChange={this.onTypeFilterChange} type="checkbox" className="fitem-ck-input"/>
                    <label htmlFor="technician_assigned" className="fitem-ck-txt">Credit Memo</label>
                  </div>
                </div>
              </div>}
            </div>
            <ul className="tabs mwhite ml-30">
              {map(status, (obj, index) =>
                <li key={`li${index}`} className={statusFilter === obj.value ? 'active' : ''}
                  onClick={() => this.onFilterChange(obj.value)}><span>{obj.key}</span></li>)}
            </ul>
          </div>
          <Table
            rowKey={record => record.uuid}
            dataSource={list?.results}
            pagination={invoicePagination}
            columns={DataTable.InvoiceWeb(this)}
            onChange={this.onInvoiceChange}
            className="table invoice_table invoice_table_web"
          />
        </div>
      </TypeOutsideAlerter>
    )
  }

  renderViews = () => {
    const { invoice_uuid, currentTab, service_order_uuid,creditMemo_uuid } = this.state;
    switch (currentTab) {
    case 0:
      return this.renderList()
    case 1:
      return <AddNewInvoiceNew
        onChangeView={this.onChangeView}
        customerId={this.props.customerId}
        customer={this.props.customer}
        invoice_uuid={invoice_uuid}
        service_order_uuid={service_order_uuid}

        // APIs
        getInvoiceList={this.getInvoiceList}
        getServiceOrderNumberList={this.props.getServiceOrderNumberList}
        addInvoice={this.props.addInvoice}
        addManualInvoice={this.props.addManualInvoice}
        getServiceOrderById={this.props.getServiceOrderById}
        addInvoiceLineItem={this.props.addInvoiceLineItem}
        deleteInvoice={this.props.deleteInvoice}
        resendInvoice={this.props.resendInvoice}
        finalizeInvoice={this.props.finalizeInvoice}
        getInvoiceDescription={this.props.getInvoiceDescription}
        getSalesTax={this.props.getSalesTax}
        getWorkOrderList={this.props.getWorkOrderList}
        getWorkOrderDetail={this.props.getWorkOrderDetail}
        getCommercialWorkOrder={this.props.getCommercialWorkOrder}
        getInvoiceById={this.props.getInvoiceById}
        invoiceProcess={this.props.invoiceProcess}

        //reducer
        Invoice={this.props.Invoice}
        ServiceOrder={this.props.ServiceOrder}
        InvoiceDescription={this.props.InvoiceDescription}
        workOrderList={this.props.workOrderList}
        WorkOrderDetail={this.props.WorkOrderDetail}
        CommercialWorkOrder={this.props.CommercialWorkOrder}
        InvoiceProcess={this.props.InvoiceProcess}
      />
    case 2:
      return <ViewEditInvoice
        invoice_uuid={invoice_uuid}
        service_order_uuid={service_order_uuid}
        onChangeView={this.onChangeView}
        customerId={this.props.customerId}
        customer={this.props.customer}
        // APIs
        getServiceOrderNumberList={this.props.getServiceOrderNumberList}
        getServiceOrderById={this.props.getServiceOrderById}
        getInvoiceList={this.getInvoiceList}
        getInvoiceById={this.props.getInvoiceById}
        addInvoice={this.props.addInvoice}
        editInvoice={this.props.editInvoice}
        deleteInvoice={this.props.deleteInvoice}
        addInvoiceLineItem={this.props.addInvoiceLineItem}
        editInvoiceLineItem={this.props.editInvoiceLineItem}
        deleteInvoiceLineItem={this.props.deleteInvoiceLineItem}
        resendInvoice={this.props.resendInvoice}
        finalizeInvoice={this.props.finalizeInvoice}
        getInvoiceDescription={this.props.getInvoiceDescription}
        getSalesTax={this.props.getSalesTax}

        //reducer
        Invoice={this.props.Invoice}
        ServiceOrder={this.props.ServiceOrder}
        InvoiceDescription={this.props.InvoiceDescription}
      />
    case 3:
      return <PaymentHistory
        invoice_uuid={invoice_uuid}
        onChangeView={this.onChangeView}
        customerId={this.props.customerId}
        // APIs
        getPaymentHistory={this.props.getPaymentHistory}
        getCustomers={this.props.getCustomers}
        deletePaymentLog={this.props.deletePaymentLog}
        postPaymentLog={this.props.postPaymentLog}
        getStaffUsers={this.props.getStaffUsers}
        getInvoiceSummary={this.props.getInvoiceSummary}
        cleanPaymentResponse={this.props.cleanPaymentResponse}

        //reducer
        CustomerList={this.props.CustomerList}
        PaymentHistory={this.props.PaymentHistory}
        CardList={this.props.cardList}
        AddCard={this.props.addCard}
        AddedLog={this.props.GetManualy}
        PostPaymentLog={this.props.PostPaymentLog}
      />
    case 4:
      return <AddCreditMemo
        creditMemo_uuid = {creditMemo_uuid}
        onChangeView={this.onChangeView}
        customerId={this.props.customerId}
        customer={this.props.customer}
  
        // APIs
        getInvoiceList={this.getInvoiceList}
        getServiceOrderNumberList={this.props.getServiceOrderNumberList}
        addInvoice={this.props.addInvoice}
        getServiceOrderById={this.props.getServiceOrderById}
        addInvoiceLineItem={this.props.addInvoiceLineItem}
        deleteInvoice={this.props.deleteInvoice}
        resendInvoice={this.props.resendInvoice}
        finalizeInvoice={this.props.finalizeInvoice}
        getInvoiceDescription={this.props.getInvoiceDescription}
        getSalesTax={this.props.getSalesTax}
        addCreditMemo={this.props.addCreditMemo}
        addCreditMemoLineItem={this.props.addCreditMemoLineItem}
        getWorkOrderTypeDescription={this.props.getWorkOrderTypeDescription}
        getCreditMemoDetails = {this.props.getCreditMemoDetails}

        //reducer
        Invoice={this.props.Invoice}
        ServiceOrder={this.props.ServiceOrder}
        InvoiceDescription={this.props.InvoiceDescription}
        WorkOrderTypeDescription={this.props.WorkOrderTypeDescription}
      />
    default:
      return this.renderList()
    }
  }

  //clear refundTypeValue
  clearRefundTypeValue = (value)=>{
    this.setState({
      refundTypeValue:null
    })
  }

  render() {
    let {
      list,
      loader,
      showDelete,
      currentTab,
      invoice_uuid,
      showLogPayment,
      is_export_popup,
      showCreatePrePay,
      showRefundPayment,
      showManualLogPayment,
      export_statement_data,
    } = this.state;
    const { customerId } = this.props;

    return (
      <div className={`block-row ${(currentTab === 1) ? '' : ''}`}>
        <div className="container">
          {loader && <Loader />}
          {this.renderViews()}
        </div>
        {showLogPayment &&
          <LogPayment
            invoice_uuid={invoice_uuid}
            customerId={customerId}
            visible={showLogPayment}
            closeDrawer={this.toggleLog}
            toggleLoader={this.toggleLoader}
            updateSummary={this.props.updateSummary}
            manualLog={false}
            // API
            getInvoiceList={this.getInvoiceList}
            getInvoiceSummary={this.getInvoiceSummary}
            getCustomers={this.props.getCustomers}
            addPaymentLog={this.props.addPaymentLog}
            getCardList={this.props.getCardList}
            addNewCard={this.props.addNewCard}
            getStaffUsers={this.props.getStaffUsers}
            // Reducers
            CustomerList={this.props.CustomerList}
            cardList={this.props.cardList}
            addCard={this.props.addCard}
            customer={this.props.customer}
            addedLog={this.props.GetManualy}
            Invoice={this.props.Invoice}
            {...this.props}
          />
        }
        {showManualLogPayment &&
          <LogPayment
            // invoice_uuid={invoice_uuid}
            customerId={customerId}
            visible={showManualLogPayment}
            closeDrawer={this.toggleManualLog}
            toggleLoader={this.toggleLoader}
            updateSummary={this.props.updateSummary}
            manualLog={true}
            
            // API
            getInvoiceList={this.getInvoiceList}
            getInvoiceSummary={this.getInvoiceSummary}
            getCustomers={this.props.getCustomers}
            addPaymentLog={this.props.addPaymentLog}
            getCardList={this.props.getCardList}
            addNewCard={this.props.addNewCard}
            getStaffUsers={this.props.getStaffUsers}
            addUnattachedPayment={this.props.addUnattachedPayment}

            // Reducers
            CustomerList={this.props.CustomerList}
            cardList={this.props.cardList}
            addCard={this.props.addCard}
            customer={this.props.customer}
            addedLog={this.props.GetManualy}
            Invoice={this.props.Invoice}
            {...this.props}
          />
        }
        {showRefundPayment && 
          <RefundPayment
            customerId={customerId}
            invoice_uuid={invoice_uuid}
            visible={showRefundPayment}
            closeDrawer={this.toggleRefund}
            toggleLoader={this.toggleLoader}
            clearRefund ={this.clearRefundTypeValue}
            getInvoiceById={this.props.getInvoiceById}
            invoice_summary={this.state.invoiceSummary}

            // Api
            getInvoiceList={this.getInvoiceList}
            getInvoiceSummary={this.getInvoiceSummary}
            getStaffUsers={this.props.getStaffUsers}
            refundPayment={this.props.refundPayment}
            actionValue={this.state.actionValue}
            refundTypeValue={this.state.refundTypeValue}
            List={list?.results}
            cardList={this.props.cardList}
            remainingCreditBalance={this.props.remainingCreditBalance}

            // Reducer
            Invoice={this.props.Invoice}
            actionIssueRefund={this.state.actionIssueRefund}
            InvoiceDescription={this.props.InvoiceDescription}
            RemainingCreditBalance={this.props.RemainingCreditBalance}
          />
        }
        {showCreatePrePay &&
          <PrePayment
            customerId={customerId}
            visible={showCreatePrePay}
            closeDrawer={this.togglePrePay}
            toggleLoader={this.toggleLoader}
            updateSummary={this.props.updateSummary}

            // API
            addNewCard={this.props.addNewCard}
            getInvoiceList={this.getInvoiceList}
            getCardList={this.props.getCardList}
            getStaffUsers={this.props.getStaffUsers}
            getInvoiceSummary={this.getInvoiceSummary}
            getServiceOrders={this.props.getServiceOrders}
            cleanPrePaymentResponse={this.props.cleanPrePaymentResponse}

            // Reducers
            addCard={this.props.addCard}
            Invoice={this.props.Invoice}
            CustomerList={this.props.CustomerList}
            customer={this.props.customer}
            cardList={this.props.cardList}
            ServiceOrders={this.props.ServiceOrders}
            {...this.props}
          />
        }
        <Modal
          title="Delete Customer"
          visible={showDelete}
          onCancel={() => this.toggleDeleteModal()}
          className="delete_user_modal"
          width={400}
          footer={[
            <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => this.toggleDeleteModal()}>No</button>,
            <button key="upload" className={`btn btn-waning`} onClick={() => this.onDeleteInvoice()}>Yes</button>,
          ]}
        >
          <div>
            <h2> Are You Sure! You want to delete selected Invoice! ?</h2>
          </div>
        </Modal>

        {/* Export popup */}
        <Modal
          title="Export Statement"
          visible={is_export_popup}
          onCancel={() => this.setState({ is_export_popup: false })}
          className="delete_user_modal"
          width={400}
          footer={[
            <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => {
              export_statement_data = Object.assign(export_statement_data, { invoice_date__gte: moment(), invoice_date__lte: moment(), format: 'pdf' })
              this.setState({ is_export_popup: false, export_statement_data })
            }}>Cancel</button>,
            <button key="upload" className={`btn btn-waning`}
              onClick={() => {
                if (list?.results?.length > 0) {
                  let { invoice_date__gte, invoice_date__lte, format } = export_statement_data;
                  let data = {
                    invoice_date__gte: moment(invoice_date__gte).format('YYYY-MM-DD'),
                    invoice_date__lte: moment(invoice_date__lte).format('YYYY-MM-DD'),
                    user__uuid: this?.props?.customerId
                  }
                  if (format === 'pdf') {
                    this.props.exportPDFStatement(data)
                  }
                  else {
                    this.props.getAccountListing({ format: 'csv', ...data })
                  }
                  this.setState({
                    loader: true,
                    is_export_popup: false
                  })
                } else {
                  export_statement_data = Object.assign(export_statement_data, { invoice_date__gte: moment(), invoice_date__lte: moment(), format: 'pdf' })
                  this.setState({ is_export_popup: false, export_statement_data })
                  message.error('No invoice to export', 10)
                }

              }}>Export</button>,
          ]
          }
        >
          <div className="flex-1">
            <div className="form-group">
              <div className="half-fitem fitem">
                <div className="half-fitem fitem">
                  <label><b>Start Date</b></label>
                  <DatePicker
                    allowClear={false}
                    value={export_statement_data?.invoice_date__gte ? moment(export_statement_data?.invoice_date__gte) : moment()}
                    onChange={(e) => {
                      export_statement_data = Object.assign(export_statement_data, { invoice_date__gte: e });
                      this.setState({
                        export_statement_data
                      })
                    }} />
                </div>
                <div className="half-fitem fitem">
                  <label><b>End Date</b></label>
                  <DatePicker
                    allowClear={false}
                    disabledDate={(endValue) => { return endValue.valueOf() <= moment(moment(export_statement_data?.invoice_date__gte, 'YYYY-MM-DD')).valueOf(); }}
                    value={export_statement_data?.invoice_date__lte ? moment(export_statement_data?.invoice_date__lte) : moment()}
                    onChange={(e) => {
                      export_statement_data = Object.assign(export_statement_data, { invoice_date__lte: e });
                      this.setState({
                        export_statement_data
                      })
                    }}
                  />
                </div>
              </div>
              <div className="fitem">
                <div className="fitem half-fitem inline-check-list">
                  <div className="half-fitem fitem">
                    <div className="fitem-check">
                      <input
                        type="radio"
                        checked={export_statement_data?.format === 'pdf'}
                        onChange={() => {
                          export_statement_data = Object.assign(export_statement_data, { format: 'pdf' });
                          this.setState({
                            export_statement_data
                          })
                        }}
                        className="fitem-ck-input" id="pdf" name="export" />
                      <label htmlFor="pdf" style={{ lineHeight: '25px' }} className="fitem-ck-txt">PDF</label>
                    </div>
                  </div>
                  <div className="half-fitem fitem">
                    <div className="fitem-check">
                      <input
                        type="radio"
                        checked={export_statement_data?.format === 'csv'}
                        onChange={() => {
                          export_statement_data = Object.assign(export_statement_data, { format: 'csv' });
                          this.setState({
                            export_statement_data
                          })
                        }}
                        className="fitem-ck-input" id="csv" name="export" />
                      <label htmlFor="csv" style={{ lineHeight: '25px' }} className="fitem-ck-txt">CSV</label>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </Modal >
      </div >
    );
  }
}

export default injectInvoicesStore ()(Invoices);